/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AdUnitsOutlined,
    ArticleOutlined,
    BadgeOutlined,
    GroupAddOutlined,
    LayersOutlined,
    LibraryBooksOutlined,
    MarkUnreadChatAltOutlined,
    ScatterPlotOutlined,
    SchoolOutlined,
    SettingsOutlined,
    TableChartOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Categorias_Formacion from "./Secciones/Seccion_Categorias_Formacion";
import Seccion_Potenciales from "./Secciones/Seccion_Potenciales";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import Seccion_Programas from "./Secciones/Seccion_Programas";
import Seccion_Potenciales_Espacio from "./Secciones/Seccion_Potenciales_Espacio";
import Seccion_Escuela from "./Secciones/Seccion_Escuela";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Crm from "./Secciones/Seccion_Crm";
import Seccion_Config_Crm from "./Secciones/Seccion_Config_Crm";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const descargarDatos = async () => {

        let dox = await obtenerCol('programas')

        const jsonString = JSON.stringify(dox.data, null, 2);
        const blob = new Blob([jsonString], {type: 'application/json'});

        // Crear una URL temporal para el Blob
        const url = URL.createObjectURL(blob);

        // Crear un elemento <a> invisible para desencadenar la descarga
        const enlace = document.createElement('a');
        enlace.href = url;
        enlace.download = 'tecnicos';

        // Añadir al DOM, hacer clic y remover
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);

        // Liberar la memoria de la URL creada
        URL.revokeObjectURL(url);
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }

    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            {/*} <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 3}}>
                <Button onClick={() => descargarDatos()}>
                    Enviar
                </Button>
            </Grid>*/}

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Potenciales (CRM)',
        icono: GroupAddOutlined,
        camino: '/Potenciales',
        categoria: 'Programas',
        Componente: <Seccion_Potenciales/>
    },
    {
        nombre: 'CRM',
        icono: TableChartOutlined,
        camino: '/Crm',
        categoria: 'Programas',
        Componente: <Seccion_Crm/>
    },
    {
        nombre: 'Programas',
        icono: LibraryBooksOutlined,
        camino: '/Programas',
        categoria: 'Pagina',
        Componente: <Seccion_Programas/>
    },
    {
        nombre: 'Escuelas',
        icono: SchoolOutlined,
        camino: '/Escuelas',
        categoria: 'Pagina',
        Componente: <Seccion_Escuela/>
    },
    {
        nombre: 'Mensajes Masivos',
        icono: MarkUnreadChatAltOutlined,
        camino: '/Mensajes',
        categoria: 'Pagina',
        Componente: <h1>Deshabilitado</h1>
    },
    {
        nombre: 'Categorias Programas',
        icono: ScatterPlotOutlined,
        camino: '/CategoriasProgramas',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias_Formacion/>
    },
    {
        nombre: 'Anuncios',
        icono: AdUnitsOutlined,
        camino: '/Anuncios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Documentos',
        icono: ArticleOutlined,
        camino: '/Documentos',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <h1>Deshabilitado</h1>
    },
    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Config Crm',
        icono: SettingsOutlined,
        camino: '/CongiCrm',
        categoria: 'Configuraciones',
        Componente: <Seccion_Config_Crm/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = [
    {

        camino: '/Potenciales/:id',
        Componente: <Seccion_Potenciales_Espacio/>
    }

]

const seccionesPerfil = []

const notificaciones = {}